import styled from 'styled-components';
import { purple, red } from 'styles/colors';

interface ColoredBackgroundProps {
    isPurple?: boolean;
}
export const ColoredBackground = styled.div<ColoredBackgroundProps>`
    background-color: ${({ isPurple = false }): string => (isPurple ? purple : red)};
    overflow: hidden;
    position: relative;
`;
